// UsersRow.tsx
import React from "react";
import { Badge, Image } from "react-bootstrap";
import applicationRole from "../../../Models/ApplicationRole";
import MemberDto from "../../../Models/MemberDto";
import { USERS_COLORS } from "../../../Utilities/UsersColors";
import { DeleteIcon, PencilIcon } from "../../Global/Icons";
import { OverlayLink } from "../../Global/Transitions";

function initials(name = "") {
  return name
    .split(" ")
    .map((n) => n[0] || "")
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function userProjects(user: MemberDto) {
  return Array.from(new Set(user.applicationRole.map((r: applicationRole) => r.projectId).filter(Boolean)));
}

function userRolesUnique(user: MemberDto) {
  const map = new Map<string, string>();
  user.applicationRole?.forEach((r) => {
    const key = (r.userRole ?? "").trim().toLowerCase();
    if (!map.has(key)) map.set(key, r.userRole);
  });
  return Array.from(map.values());
}

function getRoleClass(role: string) {
  if (!role) return "role-default";
  const key = role.trim().toLowerCase();
  return USERS_COLORS[key] ?? "role-default";
}
  
type Props = {
  user: MemberDto;
  allprojects:any[];
  onEdit?: (u: MemberDto) => void;
  onRemove?: (id: string) => void;
  disabled?:boolean;
  highestPrivilegeRole?:string;
};


export default function UsersRow({ user, allprojects, onEdit, onRemove, disabled, highestPrivilegeRole }: Props) {
  const projects = userProjects(user);
  const roles = userRolesUnique(user);
  const avatarSrc = user.imageUrl || "";
 

  //setNotAllowed(true); for all the user who is super user and current user is not superuser
  const isUserSuper = roles.some(
  r => r.trim().toLowerCase() === "super user"
);

const isCurrentUserSuper =
  highestPrivilegeRole?.trim().toLowerCase() !== "super user";

const notAllowed =
  disabled || (isUserSuper && isCurrentUserSuper);
  
  const getProjectName = (id: string) => {
   // console.log("id", id);
  const project = allprojects.find(
    (p) => p.ticketno === id
  );
  const name =
    project?.projectName??
    "";

 return name || null;   // null means "no match"
};


  return (
    <tr  className={notAllowed ? "opacity-50" : ""}
  aria-disabled={notAllowed}>
      <td style={{ width: 260 }} >
        <div className="d-flex align-items-center">
          <div style={{ width: 48, height: 48}} className="rounded-circle overflow-hidden bg-lighter text-dark border d-flex align-items-center justify-content-center me-3">
            {avatarSrc ? (
              <Image src={avatarSrc} roundedCircle style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : (
              <span style={{ fontWeight: 700 }}>{initials(user.displayName || user.email || "")}</span>
            )}
          </div>

          <div>
            <div style={{ fontWeight: 700 }}>{user.displayName ?? user.email ?? "—"}</div>
            <div style={{ color: "#9aa0ad" }}>{user.email ?? ""}</div>
          </div>
        </div>
      </td>

      <td>
        <div className="d-flex flex-wrap gap-2">
          {roles.map((r) => (
            <Badge key={r} className={getRoleClass(r) + ' role'}>
              {r}
            </Badge>
          ))}
        </div>
      </td>

      <td>
        <div className="d-flex flex-wrap gap-2">
          {projects.length === 0 ? (
            <span className="text-muted"/>
          ) : (
            projects.slice(0, 3).map((p) => (
              <Badge bg="light" text="dark" className="project" key={p} style={{  border: "1px solid rgba(0,0,0,0.04)" }} children={getProjectName(p)}/>
            ))
          )}
          {projects.length > 3 && <Badge bg="dark" text="white">... {projects.length - 3} more</Badge>}
        </div>
      </td>

      <td width={80} className="text-end">
        <OverlayLink body={<PencilIcon />} onClick={() => onEdit?.(user)} placement="left" />
      </td>

      <td width={60}>
        <OverlayLink body={<DeleteIcon />} onClick={() => onRemove?.(user.id)} className="text-danger" />
      </td>
    </tr>
  );
}
